<template>
	<!-- Deprecated !! Used by legacy route from old ecom-->
	<div></div>
</template>

<script>
export default {
	name: "InvoiceV1",
	created() {
		// TODO : Need to be rework with middleware from route or something
		return this.$router.push({
			name: 'invoice',
			params: {
				lang: this.$route.params.lang,
				uuid: this.$route.params.encryptedId,
				step : 'confirmation'
			},
		})
	},
};
</script>
